import { connect } from 'react-redux'
import { getWatermarkingQuota } from '@disco/utils/getWatermarkingQuota'
import WatermarkingQuotaAlert from './WatermarkingQuotaAlert'
import type { RootState } from 'store/configureStore'
export default connect((state: RootState) => {
  return { ...getWatermarkingQuota(state) }
})(WatermarkingQuotaAlert)
